// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.emp-reimbursement {
  width: 300px;
  height: 350px;
  text-align: center;
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  overflow: hidden;
}

.emp-reimbursement h3 {
 
  font-weight: bold;
  margin-right: 30%;
  margin-top: -3%;
  
}

.emp-reimbursement p {
  margin-top: -7%;
  color: #686868;
  font-size: small;
 
  margin-right: 70%;
}

.chart-container-reimbursement {
  width: 60%;
  height: 160px;
  margin-top: -20%;
}

.reimbursement-tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 20%;
  gap: 10px;
}

.tab-item {
  padding: 6px 14px;
  cursor: pointer;
  font-weight: bold;
  font-size: 14px;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease-in-out;
  color: #555;
}

.tab-item:hover {
  color: #3498db;
}

.tab-item.active {
  border-bottom: 3px solid #3498db;
  color: #3498db;
}




`, "",{"version":3,"sources":["webpack://./src/components/MyEmpDashboard/EmpReImbursement.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;;AAEjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;;EAEhB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,oCAAoC;EACpC,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB","sourcesContent":[".emp-reimbursement {\n  width: 300px;\n  height: 350px;\n  text-align: center;\n  background: white;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center;\n  overflow: hidden;\n}\n\n.emp-reimbursement h3 {\n \n  font-weight: bold;\n  margin-right: 30%;\n  margin-top: -3%;\n  \n}\n\n.emp-reimbursement p {\n  margin-top: -7%;\n  color: #686868;\n  font-size: small;\n \n  margin-right: 70%;\n}\n\n.chart-container-reimbursement {\n  width: 60%;\n  height: 160px;\n  margin-top: -20%;\n}\n\n.reimbursement-tabs {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 20%;\n  gap: 10px;\n}\n\n.tab-item {\n  padding: 6px 14px;\n  cursor: pointer;\n  font-weight: bold;\n  font-size: 14px;\n  border-bottom: 3px solid transparent;\n  transition: all 0.3s ease-in-out;\n  color: #555;\n}\n\n.tab-item:hover {\n  color: #3498db;\n}\n\n.tab-item.active {\n  border-bottom: 3px solid #3498db;\n  color: #3498db;\n}\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
